import $ from 'jquery';
$(function () {
    let token = $('meta[name="_token"]').attr('content');
    let popupWrapper = $('[data-popup-site-wrapper]');
    function ajaxPopupOpen(popupName)
    {
        let popup = popupWrapper.find('[data-popup-instance="' + popupName + '"]');
        if (popup.length) {
            popup.fadeIn();
            return;
        }
        $.ajax({
            url: '/ajax/popup/' + popupName,
            dataType: 'json',
            type: "POST",
            data: {_token:token},
            success: function (response) {
                let popup = $(response.popup);
                popupWrapper.append(popup);
                popup.fadeIn();
            }
        });
    }

    $(document).on('touchend click', '[data-open-popup]', function (e) {
        e.preventDefault();
        let obj = $(this);
        let popupName = obj.data('name-popup')
        $('[data-popup]').hide();
        ajaxPopupOpen(popupName);
    });

    $(document).on('touchend click', '[data-popup-close], [data-popup-overlay]', function (e) {
        e.preventDefault();
        $(this).closest('[data-popup]').fadeOut();
    });

    $(document).on('keydown', function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            $('[data-popup]:visible').fadeOut();
        }
    });

    $(document).on('touchend click', '[data-popup-download-show]', loadPopupDownload);

    function loadPopupDownload(e)
    {
        e.preventDefault();
        let popupDownload = $('[data-popup-download]');

        if (popupDownload.length) {
            popupDownload.fadeIn();
        } else {
            $.ajax({
                url: '/ajax/popup/download',
                dataType: 'json',
                type: "POST",
                data: {_token:token},
                success: function (response) {
                    popupWrapper.append(response.popup);
                    $('[data-popup-download]').fadeIn();
                }
            });
        }
    }

    (function PhonePrefixHandler()
    {
        function updatePhonePrefixFlag(selectElement)
        {
            const selectedOption = selectElement.find('option:selected');
            const countryCode = selectedOption.data('code');
            const imageContainer = selectElement.closest('[data-form-select]').find('[data-country-flag] span');
            imageContainer.removeClass();

            if (countryCode) {
                imageContainer.addClass('fi fi-' + countryCode.toLowerCase());
            } else {
                imageContainer.addClass('fi fi-eu');
            }
        }

        $(document).on('change', 'select[name="phone_prefix"]', function () {
            updatePhonePrefixFlag($(this));
        });

        $('select[name="phone_prefix"]').each(function () {
            updatePhonePrefixFlag($(this));
        });
    })();
});
